<template>
	<div id="forgot-form">
		<!-- <div class="detailView"> -->
		<loading
			:active.sync="isLoading"
			:can-cancel="true"
			:on-cancel="onCancel"
			:is-full-page="fullPage"
		></loading>
		<div class="appView">
			<div class="gatekeeperView resetPassword">
				<div class="gatekeeperContentView">
					<div class="logo"></div>

					<div class="gatekeeperForm">
						<div class="formHeader">
							<div class="title">Reset Your Password</div>
							<div class="separator"></div>
						</div>

						<div class="formContent tableView">
							<b-alert
								:show="dismissCountDown"
								dismissible
								variant="danger"
								@dismissed="dismissCountDown = 0"
								@dismiss-count-down="countDownChanged"
								>{{ err }}
							</b-alert>
							<div class="tableSection sectionCredentials">
								<div class="block inputCell email isFocused">
									<div class="title">Email</div>
									<div class="input placeholder">
										<input
											v-model="email"
											type="email"
											placeholder="name@domain.com"
											class="form-control"
											v-on:keyup.enter="resetPassword"
										/>
									</div>
								</div>
								<a href="#" class="footer"
									>Enter the email you used when signing up and we’ll send you a
									link to reset your password.</a
								>
							</div>

							<div
								class="button buttonLarge"
								:class="[!email ? 'buttonDisabled' : 'buttonTint']"
							>
								<div class="title" @click="resetPassword">
									Send Password Reset Email
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="navBar">
          <div class="title">Reset your password</div>
        </div>
        <div class="detailsList">
          <div class="tableSection sectionEmail">
            <div class="block email">
                <div class="title">Email</div>
                <div class="detail"><input v-model="email" type="email" class="form-control"/></div>
            </div>
          </div>
          <br>
          <div class="tableSection sectionName">
            <div class="block firstName">
              <div class="title"><p><a href="/signin">Back to signin</a></p></div>
                <div class="detail"><button class="btn btn-success" type="submit" @click="resetPassword">Send Code</button></div>
            </div>
          </div>
        </div> -->
		<!-- </div> -->
	</div>
</template>

<script>
import Auth from "@aws-amplify/auth";
import Amplify from "@aws-amplify/core";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
	name: "Forgot",
	data() {
		return {
			email: "",
			isLoading: false,
			fullPage: true,
			dismissSecs: 5,
			dismissCountDown: 0,
			err: ""
		};
	},
	components: {
		Loading
	},
	methods: {
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		},
		onCancel() {
			console.log("User cancelled the loader.");
		},
		resetPassword() {
			this.isLoading = true;
			Auth.forgotPassword(this.email)
				.then(data => {
					//console.log(data);
					this.$router.push({ name: "reset", query: { email: this.email } });
				})
				.catch(err => {
					this.isLoading = false;
					this.err = err.message;
					this.dismissCountDown = this.dismissSecs;
				});
		}
	}
};
</script>
